module.exports = __webpack_public_path__ + "img/20.e325c312.jpg";